import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Stack } from "@mui/material";

import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";
import CachedIcon from "@mui/icons-material/Cached";

import OrganisationList from "./component/T_Organisation";
import OrganisationModal from "./component/M_Organisation";

import useOrganisation from "../../../hooks/super/useOrganisation";
import useAuth from "../../../hooks/useAuth";
import { UserType, normalizeUserType } from "../../../utils/constants";

import { CollapseAlert } from "../../../components/pages/common/styled";
import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import PrimaryButton from "../../../components/pages/_new/super/common/PrimaryButton";
import OutlinedButton from "../../../components/pages/_new/super/common/OutlinedButton";

function SAOrganisation() {
  const { organisations, setErr, errMsg, getOrganisations, rows_per_page } = useOrganisation();
  const { isAuthenticated, sauser } = useAuth();
  const [errOpen, setErrOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const refresh = () => {
    getOrganisations(rows_per_page, 0);
  };
  React.useEffect(() => {
    if (isAuthenticated) getOrganisations(rows_per_page, 0);
    return () => setErr(null);
  }, [isAuthenticated, rows_per_page, getOrganisations, setErr]);
  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  return (
    <React.Fragment>
      <Helmet title="SA Organisation" />
      <PageHeader
        title="Organisation Management"
        description="Manage all organisations in the system"
        actions={
          <>
            <OutlinedButton
              onClick={refresh}
              startIcon={<CachedIcon style={{ width: 20, height: 20 }} />}
            >
              Refresh
            </OutlinedButton>
            <PrimaryButton
              onClick={handleOpen}
              startIcon={<AddCircleOutlineIcon style={{ width: 20, height: 20 }} />}
              disabled={null === organisations || normalizeUserType(sauser?.userType || sauser?.role) === UserType.ORG_USER}
            >
              Add Organisation
            </PrimaryButton>
          </>
        }
      />
      <Box sx={{ mb: 4 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>
      <Stack spacing={4}>
        <OrganisationList />
      </Stack>
      <OrganisationModal open={open} handleClose={handleClose} />
    </React.Fragment>
  );
}
export default SAOrganisation;
